import React from 'react';
import { Icon } from './Icon.js';
export const IconBullseyeFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M9,17c-4.411,0-8-3.589-8-8S4.589,1,9,1s8,3.589,8,8-3.589,8-8,8Zm0-14.5c-3.584,0-6.5,2.916-6.5,6.5s2.916,6.5,6.5,6.5,6.5-2.916,6.5-6.5-2.916-6.5-6.5-6.5Z", fill: "currentColor" }),
        React.createElement("path", { d: "M9,14c-2.757,0-5-2.243-5-5s2.243-5,5-5,5,2.243,5,5-2.243,5-5,5Zm0-8.5c-1.93,0-3.5,1.57-3.5,3.5s1.57,3.5,3.5,3.5,3.5-1.57,3.5-3.5-1.57-3.5-3.5-3.5Z", fill: "currentColor" }),
        React.createElement("circle", { cx: "9", cy: "9", r: "2", fill: "currentColor", "data-color": "color-2" })));
};
//# sourceMappingURL=IconBullseyeFill18.js.map